import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Credly|Templates|Exceptions|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ShareCredlyBadging,
	portal: 'SP',
};

export type SPToolCredlyTemplateExceptionsLocNames =
	| 'SPToolCredlyTemplateExceptionsTitle'
	| 'SPToolCredlyTemplateExceptionsID'
	| 'SPToolCredlyTemplateExceptionsName'
	| 'SPToolCredlyTemplateExceptionsNotificationAnnouncement';

export const spToolCredlyTemplateExceptionsLocs: LocDefs<SPToolCredlyTemplateExceptionsLocNames> = {
	SPToolCredlyTemplateExceptionsTitle: {
		defaultValue: 'Credly Duplicate Issuing',
		description: 'Title for the exceptions section.',
		displayPath: `${pathStart}Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPToolCredlyTemplateExceptionsID: {
		defaultValue: 'Template ID',
		description: 'Template ID column header.',
		displayPath: `${pathStart}ID Column`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPToolCredlyTemplateExceptionsName: {
		defaultValue: 'Name',
		description: 'Name column header.',
		displayPath: `${pathStart}Name Column`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPToolCredlyTemplateExceptionsNotificationAnnouncement: {
		defaultValue:
			"The following badges have duplicate issuing turned off. This can potentially cause issues with candidates receiving badges until it is turned on. Please ensure the 'allow duplicates' setting is enabled in Credly for all catalog items.",
		description: 'A message shown when there are duplicate Credly IDs.',
		displayPath: `${pathStart}Duplicate IDs Notification`,
		displayType: 'Notification',
		...sharedProperties,
	},
};

export type SPToolCredlyTemplateExceptionsLocType = LocMap<SPToolCredlyTemplateExceptionsLocNames>;
